import { makeActionCreator } from '../../../utilities'
import { QuickActionsConstants } from './quickActions.constants'

export const setQuickActions = makeActionCreator(QuickActionsConstants.SET_QUICK_ACTIONS, 'quickActions')
export const setQuickActionButtons = makeActionCreator(
  QuickActionsConstants.SET_QUICK_ACTION_BUTTONS,
  'quickActionButtons'
)
export const filterQuickActionButtons = makeActionCreator(
  QuickActionsConstants.FILTER_QUICK_ACTION_BUTTONS,
  'selectedQuickActionId'
)
export const setFilteredQuickActionButtons = makeActionCreator(
  QuickActionsConstants.SET_FILTERED_QUICK_ACTION_BUTTONS,
  'filteredQuickActionButtons'
)
export const setQuickActionButtonRows = makeActionCreator(
  QuickActionsConstants.SET_QUICK_ACTION_BUTTON_ROWS,
  'quickActionButtonRows'
)
export const setMobileQuickActionButtonRows = makeActionCreator(
  QuickActionsConstants.SET_MOBILE_QUICK_ACTION_BUTTON_ROWS,
  'mobileQuickActionButtonRows'
)
export const setSelectedQuickActionButton = makeActionCreator(
  QuickActionsConstants.SET_SELECTED_QUICK_ACTION_BUTTON,
  'selectedQuickActionButton'
)
export const updateQuickActionButton = makeActionCreator(
  QuickActionsConstants.UPDATE_QUICK_ACTION_BUTTON,
  'updatedQuickActionButton'
)
export const setParentQuickActionLabel = makeActionCreator(
  QuickActionsConstants.SET_PARENT_QUICK_ACTION_LABEL,
  'parentQuickActionLabel'
)
export const setIsDrainButtonType = makeActionCreator(QuickActionsConstants.SET_IS_DRAIN_BUTTON_TYPE)
export const setIsMedicationButtonType = makeActionCreator(QuickActionsConstants.SET_IS_MEDICATION_BUTTON_TYPE)
export const setIsProcedureButtonType = makeActionCreator(QuickActionsConstants.SET_IS_PROCEDURE_BUTTON_TYPE)
export const setIsVitalButtonType = makeActionCreator(QuickActionsConstants.SET_IS_VITAL_BUTTON_TYPE)
export const setIsCardiacButtonType = makeActionCreator(QuickActionsConstants.SET_IS_CARDIAC_BUTTON_TYPE)
export const setIsIntubationButtonType = makeActionCreator(QuickActionsConstants.SET_IS_INTUBATION_BUTTON_TYPE)
export const setIsAirwayButtonType = makeActionCreator(QuickActionsConstants.SET_IS_AIRWAY_BUTTON_TYPE)
export const setIsChildbirthOBButtonType = makeActionCreator(QuickActionsConstants.SET_IS_CHILDBIRTHOB_BUTTON_TYPE)
export const setIsExtricationButtonType = makeActionCreator(QuickActionsConstants.SET_IS_EXTRICATION_BUTTON_TYPE)
export const setIsHospitalNotifyButtonType = makeActionCreator(QuickActionsConstants.SET_IS_HOSPITAL_NOTIFY_BUTTON_TYPE)
export const setIsInitiateIVButtonType = makeActionCreator(QuickActionsConstants.SET_IS_INITIATE_IV_BUTTON_TYPE)
export const setIsImmobilizationButtonType = makeActionCreator(QuickActionsConstants.SET_IS_IMMOBILIZATION_BUTTON_TYPE)
export const setIsMedicalConsultButtonType = makeActionCreator(QuickActionsConstants.SET_IS_MEDICAL_CONSULT_BUTTON_TYPE)
export const setIsOperationsButtonType = makeActionCreator(QuickActionsConstants.SET_IS_OPERATIONS_BUTTON_TYPE)
export const setIsRescueButtonType = makeActionCreator(QuickActionsConstants.SET_IS_RESCUE_BUTTON_TYPE)
export const setIsVentilatorButtonType = makeActionCreator(QuickActionsConstants.SET_IS_VENTILATOR_BUTTON_TYPE)
export const setIsBloodProductAdministrationButtonType = makeActionCreator(
  QuickActionsConstants.SET_IS_BLOOD_PRODUCT_ADMINISTRATION_BUTTON_TYPE
)
export const setIsWoundCareButtonType = makeActionCreator(QuickActionsConstants.SET_IS_WOUND_CARE_BUTTON_TYPE)
export const setIsCriticalCareButtonType = makeActionCreator(QuickActionsConstants.SET_IS_CRITICAL_CARE_BUTTON_TYPE)
export const setIsTitrateButtonType = makeActionCreator(QuickActionsConstants.SET_IS_TITRATE_BUTTON_TYPE)
export const setIsLabsButtonType = makeActionCreator(QuickActionsConstants.SET_IS_LABS_BUTTON_TYPE)
export const setIsVentricularAssistDeviceButtonType = makeActionCreator(
  QuickActionsConstants.SET_IS_VENTRICULAR_ASSIST_DEVICE_BUTTON_TYPE
)
export const setAddIntubationToTimeline = makeActionCreator(
  QuickActionsConstants.SET_ADD_INTUBATION_TO_TIMELINE,
  'addIntubationToTimeline'
)
export const setAddMedicationToTimeline = makeActionCreator(
  QuickActionsConstants.SET_ADD_MEDICATION_TO_TIMELINE,
  'addMedicationToTimeline'
)
export const setAddCardiacToTimeline = makeActionCreator(
  QuickActionsConstants.SET_ADD_CARDIAC_TO_TIMELINE,
  'addCardiacToTimeline'
)
export const setAddDrainToTimeline = makeActionCreator(
  QuickActionsConstants.SET_ADD_DRAIN_TO_TIMELINE,
  'addDrainToTimeline'
)
export const setAddAirwayToTimeline = makeActionCreator(
  QuickActionsConstants.SET_ADD_AIRWAY_TO_TIMELINE,
  'addAirwayToTimeline'
)
export const setAddChildbirthOBToTimeline = makeActionCreator(
  QuickActionsConstants.SET_ADD_CHILDBIRTHOB_TO_TIMELINE,
  'addChildbirthOBToTimeline'
)
export const setAddExtricationToTimeline = makeActionCreator(
  QuickActionsConstants.SET_ADD_EXTRICATION_TO_TIMELINE,
  'addExtricationToTimeline'
)
export const setAddHospitalNotifyToTimeline = makeActionCreator(
  QuickActionsConstants.SET_ADD_HOSPITAL_NOTIFY_TO_TIMELINE,
  'addHospitalNotifyToTimeline'
)
export const setAddInitiateIVToTimeline = makeActionCreator(
  QuickActionsConstants.SET_ADD_INITIATE_IV_TO_TIMELINE,
  'addInitiateIVToTimeline'
)
export const setAddImmobilizationToTimeline = makeActionCreator(
  QuickActionsConstants.SET_ADD_IMMOBILIZATION_TO_TIMELINE,
  'addImmobilizationToTimeline'
)
export const setAddMedicalConsultToTimeline = makeActionCreator(
  QuickActionsConstants.SET_ADD_MEDICAL_CONSULT_TO_TIMELINE,
  'addMedicalConsultToTimeline'
)
export const setAddOperationsToTimeline = makeActionCreator(
  QuickActionsConstants.SET_ADD_OPERATIONS_TO_TIMELINE,
  'addOperationsToTimeline'
)
export const setAddRescueToTimeline = makeActionCreator(
  QuickActionsConstants.SET_ADD_RESCUE_TO_TIMELINE,
  'addRescueToTimeline'
)
export const setAddVentilatorToTimeline = makeActionCreator(
  QuickActionsConstants.SET_ADD_VENTILATOR_TO_TIMELINE,
  'addVentilatorToTimeline'
)
export const setAddWoundCareToTimeline = makeActionCreator(
  QuickActionsConstants.SET_ADD_WOUND_CARE_TO_TIMELINE,
  'addWoundCareToTimeline'
)
export const setAddVentricularAssistDeviceToTimeline = makeActionCreator(
  QuickActionsConstants.SET_ADD_VENTRICULAR_ASSIST_DEVICE_TO_TIMELINE,
  'addVentricularAssistDeviceToTimeline'
)
export const setAddCriticalCareToTimeline = makeActionCreator(
  QuickActionsConstants.SET_ADD_CRITICAL_CARE_TO_TIMELINE,
  'addCriticalCareToTimeline'
)
export const setSavedQuickActionButtons = makeActionCreator(
  QuickActionsConstants.SET_SAVED_QUICK_ACTION_BUTTONS,
  'selectedButton'
)
export const setResponse = makeActionCreator(QuickActionsConstants.SET_RESPONSE, 'response')
export const resetQuickActionState = makeActionCreator(QuickActionsConstants.RESET_STATE)
export const setSelectedQuickActionButtonType = makeActionCreator(
  QuickActionsConstants.SET_SELECTED_QUICK_ACTION_BUTTON_TYPE
)
export const setSavedQuickActionButtonsForNotification = makeActionCreator(
  QuickActionsConstants.SET_SAVED_QUICK_ACTION_BUTTONS_FOR_NOTIFICATION,
  'savedQuickActionButtonsForNotification'
)

export const setLocalNotifications = makeActionCreator(
  QuickActionsConstants.SET_LOCAL_NOTIFICATIONS,
  'localNotifications'
)

export const setLocalNotificationsToCancel = makeActionCreator(
  QuickActionsConstants.SET_LOCAL_NOTIFICATIONS_TO_CANCEL,
  'localNotificationsToCancel'
)

export const resetLocalNotificationsToCancel = makeActionCreator(
  QuickActionsConstants.RESET_LOCAL_NOTIFICATIONS_TO_CANCEL
)
